import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { environment } from '../environments/environment';
import { MENU_CONFIG, MenuConfig } from '@core/services/menu.service';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';

import { routes } from './app.routes';
import { AuthInterceptor } from '@core/auth/interceptors/auth.interceptor';

registerLocaleData(localeNl);

const koppelsMenuConfig: MenuConfig = {
  menuItems: [
    {
      path: '/dashboard',
      label: 'Dashboard',
      icon: 'dashboard',
    },
    {
      path: '/koppels',
      label: 'Koppels',
      icon: 'list',
      children: [
        {
          path: '/witvlees',
          label: 'Witvlees',
          icon: 'list',
        },
        {
          path: '/starters',
          label: 'Starters',
          icon: 'list',
        },
        {
          path: '/rose',
          label: 'Rose',
          icon: 'list',
        },
        {
          path: '/recente-imports',
          label: 'Recente Imports',
          icon: 'rotate',
        },
      ],
    },
    {
      path: '/slaughter-lists',
      label: 'Slachtlijsten',
      icon: 'axe_battle',
    },
    {
      path: '/starters-lists',
      label: 'Starterslijsten',
      icon: 'arrow-right-from-bracket',
    },
    {
      path: '/health-registrations',
      label: 'Gezondheidsregistraties',
      icon: 'stethoscope',
    },
    {
      path: '/medication-registrations',
      label: 'Medicijnregistraties',
      icon: 'syringe',
    },
    // {
    //   path: '/feed',
    //   label: 'Voer',
    //   icon: 'feed',
    // },
    {
      path: '/settings',
      label: 'Instellingen',
      icon: 'settings',
      children: [
        {
          path: '/settings/medications',
          label: 'Medicijnen',
          icon: 'pills',
        },
        {
          path: '/settings/financial-codes',
          label: 'Financiële codes',
          icon: 'money-bill-trend-up',
        },
        {
          path: '/settings/setup-codes',
          label: 'Opzetcodes',
          icon: 'cogs',
        },
        {
          path: '/settings/booking-items',
          label: 'Boeking items',
          icon: 'package'
        },
      ]
    }
  ],
  appName: 'Vdv Koppels',
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    {
      provide: 'ENVIRONMENT',
      useValue: environment,
    },
    { provide: MENU_CONFIG, useValue: koppelsMenuConfig },
    { provide: LOCALE_ID, useValue: 'nl-NL' },
  ],
};
